import type { FaireProductEntity } from "../../entity_types/product";

export const p_j4aejz9qde: FaireProductEntity = {
  token: "p_j4aejz9qde",
  type: "product",
  name: "Blue Apatite Slab",
  brandToken: "b_5wk9sqf7b2",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/57265c803cc9e79cbf1ca3ab2c7db679c870baa27b8c7f81e0cadc45fc458dac.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ba8fcf27dbd613d522fd67e1651a6310a5b560a2376fa00d1932079da6e2caee.jpeg",
  ],
  priceDollars: 27.02,
  description:
    "Feeling stuck in a rut? Let Blue Apatite be your guide to a more empowered, inspired life. This remarkable gemstone is a powerful ally in boosting confidence, motivation, and creativity.\n\n * Enhances self-esteem and inner strength \n * Increases drive and determination \n * Promotes open-mindedness and adaptability \n * Supports the healing of bone and cartilage \nBlue Apatite is a transformative crystal that helps you break free from self-limiting beliefs and step into your fullest potential. As you work with this stone, you'll notice a surge of courage and clarity, empowering you to take bold action towards your goals.\n\nWhether you're tackling a creative project, chasing a big dream, or simply wanting to feel more self-assured in your daily life, Blue Apatite will be your steadfast companion. Its energizing influence will help you cultivate a more positive self-image, unleash your innovative ideas, and approach life with an open and adaptable mindset.\n",
  tags: [],
  msrpDollars: 54.04,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:52.331Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
